import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import Typography from 'antd/es/typography';
import message from 'antd/es/message';

import useAuth from 'hooks/useAuth';

import PublicLayout from 'layouts/Public.layout';
import ResetPasswordForm from '../components/ResetPasswordForm';

import { LOGIN_PAGE_PATH } from '../index';

const ResetPasswordWrapper = styled.div`
  max-width: 364px;
`;

const ResetPasswordInfo = styled.p`
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;

  display: flex;
  align-items: center;
  text-align: center;
  color: #232526;
  margin: 24px 0;
`;

const ResetPasswordPage = () => {
  const history = useHistory();
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [password, setPassword] = useState('');

  const validatePassword = (password) => {
    return {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[^A-Za-z0-9]/.test(password),
    };
  };

  const passwordConditions = validatePassword(password);

  useEffect(() => {
    if (!auth.state.currentUser) {
      history.push(LOGIN_PAGE_PATH);
    }
  }, [auth.state, history]);

  useEffect(() => {
    if (error) {
      message.error(error.message, 2);
    }
  }, [error]);

  const onSubmit = useCallback(({ newPassword, resetCode }) => {
    setError(null);
    setIsLoading(true);

    const resetPasswordPromise = auth.state.requiresPassReset
      ? auth.actions.completePasswordResetChallenge({ password: newPassword })
      : auth.actions.completePasswordReset({ password: newPassword, resetCode });

    resetPasswordPromise
      .then(() => {
        message.success('Your Password has been changed!', 2);
        history.push('/');
      })
      .catch(err => {
        if (err.code === 'INVALID_RESET_FLOW') {
          history.push(LOGIN_PAGE_PATH);
        } else if (err.code === 'InvalidPasswordException') {
          err.message = err.message.substr(err.message.indexOf(':') + 2);
          setError(err);
        } else {
          setError(err);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });

  }, [auth.actions, history, auth.state.requiresPassReset]);

  return (
    <PublicLayout>
      <ResetPasswordWrapper>
        <Typography.Title level={2} align="middle" style={{ lineHeight: '38px' }}>
          Reset password
        </Typography.Title>
        <ResetPasswordInfo>
          Please enter
          {!auth.state.requiresPassReset ? ' the reset code your received by email and ' : ' '}
          your new password for your account
        </ResetPasswordInfo>
        <ResetPasswordForm onSubmit={onSubmit} requiresCode={!auth.state.requiresPassReset} isLoading={isLoading} validatePassword={validatePassword} setPassword={setPassword} passwordConditions={passwordConditions}/>
      </ResetPasswordWrapper>
    </PublicLayout>
  );
};

export default ResetPasswordPage;
